import React, { useState, useEffect } from "react";
import Table from "../../../sharedComponents/Table";
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import { FaPlus, FaTrash, FaPen, FaDownload } from 'react-icons/fa';
import useDataAttendees from '../../../../dataHooks/useDataAttendees'
import AddEditAttendeesModal from "./AddEditAttendeesModal";
import DeleteAttendeeModal from "./DeleteAttendeeModal";
import { checkHasEditEventPermissions, getClientSubdomain } from '../../../../utils';
import useIsMobileView from "../../../../hooks/useIsMobileView";

export default ({
  eventData = {}
}) => {
  const clientSubdomain = getClientSubdomain()
      
  const isStarSubdomain = (clientSubdomain === 'star')

  const isMobileView = useIsMobileView();

  const hasEditPermissions = checkHasEditEventPermissions();

  const {
    isLoading,
    attendees,
    fetchAttendees,
    downloadAttendees
  } = useDataAttendees()

  const filteredAttendees = attendees.filter(({ status }) => status !== 'Archived')

  useEffect(() => {
    fetchAttendees({ eventId : eventData.id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.id])

  const [addEditAttendeeObj, setAddEditAttendeeObj] = useState(undefined)
  const [deleteAttendeeObj, setDeleteAttendeeObj] = useState(undefined)

  const onAddNewAttendee = () => {
    setAddEditAttendeeObj({})
  }

  const onEditAttendee = (attendee) => {
    setAddEditAttendeeObj(attendee)
  }

  const onAddEditAttendeeSuccess = () => {
    setAddEditAttendeeObj(undefined)
    fetchAttendees({ eventId : eventData.id })
  }

  const onDeleteAttendee = (attendee) => {
    setDeleteAttendeeObj(attendee)
  }

  const onDeleteAttendeeSuccess = () => {
    setDeleteAttendeeObj(undefined)
    fetchAttendees({ eventId : eventData.id })
  }

  const onDownloadAttendees = async () => {
    await downloadAttendees({ eventId : eventData.id })
  }

  const columns = [
    {
      field: 'name',
      title: 'Name',
    },
    {
      field: 'email',
      title: isStarSubdomain ? 'School Email' : 'Email',
    }
  ]

  if (isStarSubdomain) {
    columns.push({
      field: 'date',
      title: 'Date',
    })
    columns.push({
      field: 'district',
      title: 'District',
    })
  }

  columns.push({
    field: 'status',
    title: 'Status',
  })

  if (hasEditPermissions) {
    const actionColumn = {
      title: 'Actions',
      headerStyle: { textAlign: 'right', paddingRight: '20px' },
      renderer: (data) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button
              style={{
                display: 'inline-flex',
                border: 'none',
                position: 'relative',
                color: '#0280c6',
                marginRight: '10px'
              }}
              onClick={() => onEditAttendee(data)}
            >
              <FaPen style={{ marginRight: '10px' }} />
              <span style={{ }}>{'Edit'}</span>
            </Button>
            <Button
              style={{
                display: 'inline-flex',
                border: 'none',
                position: 'relative',
                color: '#ef0c0c'
              }}
              onClick={() => onDeleteAttendee(data)}
            >
              <FaTrash style={{ marginRight: '10px' }} />
              <span style={{ }}>{'Remove'}</span>
            </Button>
          </div>
        )
      }
    }
    columns.push(actionColumn)
  }

  return (
    <div
      style={{
        padding: '20px'
      }}
    >
      {
        Boolean(addEditAttendeeObj) &&
        <AddEditAttendeesModal 
          attendee={addEditAttendeeObj}
          eventId={eventData.id}
          onClose={() => setAddEditAttendeeObj(undefined)}
          onSuccess={onAddEditAttendeeSuccess}
        />
      }
      {
        Boolean(deleteAttendeeObj) &&
        <DeleteAttendeeModal 
          attendee={deleteAttendeeObj}
          onClose={() => setDeleteAttendeeObj(undefined)}
          onSuccess={onDeleteAttendeeSuccess}
        />
      }
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {`Attendees (${isLoading ? '.' : filteredAttendees.length})`}
        </div>
        {
          hasEditPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={onAddNewAttendee}
          >
            <FaPlus style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Add Attendee'}</span>
          </Button>
        }
        <Button
          style={{
            display: 'inline-flex',
            padding: '8px 16px',
            marginRight: '20px'
          }}
          onClick={onDownloadAttendees}
        >
          <FaDownload style={{ marginRight: '10px', color: '#0280c6' }} />
          <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Download'}</span>
        </Button>
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{ padding: '20px', color: '#565656' }}>
            <Table
              columns={columns}
              data={filteredAttendees}
              mobileMode={isMobileView}
            />
          </div>
      }
    </div>
  )
}